<template>
  <v-card>
    <GChart
        type="ColumnChart"
        :data="chartData"
        :options="chartOptions"
    />
  </v-card>
</template>

<script>
export default {
  name: 'ChartOmset',
  data: () => ({
    chartData: [
      ['Year', 'Trx'],
      ['1', 4000000000],
      ['2', 3200000000],
      ['3', 5000000000],
      ['4', 3500000000]
    ],
    chartOptions: {
      height: 400,
      title: 'Amount Transaksi',
      legend: { position: 'none' },
      chart: {
        legend: { position: 'top' },
        title: 'Company Performance',
        subtitle: 'Sales, Expenses, and Profit: 2014-2017'
      }
    }
  })
}
</script>

<style scoped>

</style>
